{
  "login": {
    "join": {
      "fields": {
        "phone": {
          "phoneNumber": {
            "pattern": "Please enter a valid phone number",
            "required": "Phone number is required"
          },
          "pattern": "",
          "required": ""
        },
        "guardianPhone": {
          "phoneNumber": {
            "pattern": "Please enter a valid phone number",
            "required": "Guardian phone number is required"
          },
          "pattern": "",
          "required": ""
        },
        "gender": {
          "required": "Gender is required"
        },
        "acceptFinnairPlusRules": {
          "required": "Please read and accept the rules of the Finnair Plus program to continue."
        }
      }
    }
  }
}
